import { Injectable } from '@angular/core';

import { parsePhoneNumber } from 'libphonenumber-js';

@Injectable()
export class PhonesService {
  setPhoneNumber(phoneNumber: string): string {
    if (phoneNumber) {
      if (phoneNumber[0] !== '+') {
        phoneNumber = '+' + phoneNumber.trim();
      }
      phoneNumber = parsePhoneNumber(phoneNumber).format('E.164').toString();
    }
    return phoneNumber;
  }

  formatPhoneNumber(phoneNumber: string): string | null {
    if (!phoneNumber) {
      return null;
    }
    if (phoneNumber[0] !== '+') {
      phoneNumber = '+' + phoneNumber;
    }
    return parsePhoneNumber(phoneNumber).format('NATIONAL');
  }
}
